import { useEffect, useState } from "react"
import { WasmRunner } from "@coherentglobal/wasm-runner"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import { InstallButton } from "./components/InstallButton"
import { InputsIcon } from "./icons/InputsIcon"
import { OutputsIcon } from "./icons/OutputsIcon"
import { PerformanceIcon } from "./icons/PerformanceIcon"
import { PerformanceForm } from "./components/PerformanceForm"
import { InputTab } from "./components/input/InputTab"
import { OutputTab } from "./components/output/OutputTab"
import { InformationCircleIcon } from "@heroicons/react/24/outline"
import { AboutTab } from "./components/AboutTab"
import { ShareButton } from "./components/ShareButton"
import { QRCodeButton } from "./components/QRCodeButton"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function App() {
  const [runner, setRunner] = useState<null | WasmRunner>(null)
  const [response, setResponse] = useState<any>({})
  const [tabIndex, setTabIndex] = useState(0)

  const initWasmRunner = async () => {
    const wasmRunner = new WasmRunner({
      id: "638de46a-6e92-41bf-ab8f-47266d17800d",
      url: "/Revolving_Calculation_and_ECL_Model_PR.zip",
    })
    await wasmRunner.initialize()
    setRunner(wasmRunner)
  }

  useEffect(() => {
    const init = async () => {
      await initWasmRunner()
    }

    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="h-full bg-form-medium">
      <div className="bg-form-light w-full px-3 h-16 flex items-center justify-between pt-1">
        <a href="https://coherent.global" target="_blank" rel="noreferrer">
          <img src="/coherent-logo.png" alt="Coherent" className="h-8" />
        </a>
        <div className="flex space-x-3">
          <QRCodeButton />
          <ShareButton />
          <div className="install-button-container">
            <InstallButton />
          </div>
        </div>
      </div>

      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabPanel className="space-y-6">
          <InputTab
            response={response}
            setResponse={setResponse}
            setTabIndex={setTabIndex}
            initWasmRunner={initWasmRunner}
            runner={runner!}
          />
        </TabPanel>
        <TabPanel className="space-y-6">
          <OutputTab responseData={response.response_data} />
        </TabPanel>
        <TabPanel>
          <PerformanceForm runner={runner!} />
        </TabPanel>
        <TabPanel>
          <AboutTab />
        </TabPanel>

        <TabList>
          <Tab>
            <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
              <InputsIcon className="h-6 w-6" />
              <span className="mt-2 text-xs">INPUTS</span>
            </div>
          </Tab>
          <Tab>
            <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
              <OutputsIcon className="h-6 w-6" />
              <span className="mt-2 text-xs">OUTPUTS</span>
            </div>
          </Tab>
          <Tab>
            <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
              <PerformanceIcon className="h-6 w-6" />
              <span className="mt-2 text-xs">PERFORMANCE</span>
            </div>
          </Tab>
          <Tab>
            <div className="absolute top-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center">
              <InformationCircleIcon className="h-6 w-6" />
              <span className="mt-2 text-xs">ABOUT</span>
            </div>
          </Tab>
        </TabList>
      </Tabs>
      <ToastContainer limit={1} />
    </div>
  )
}

export default App

